import React from "react"
import { useNavigate, useParams, useLocation } from "react-router-dom"
import { useSelector } from "react-redux"
import PropTypes from "prop-types"
import { Button, Flex, Typography } from "antd"
import styles from "./EmbeddedBooking.module.css"
import { routes } from "router"
import { selectedPaymentMethodIdSelector } from "store/user"
import { useTheme } from "context/AntdThemeContext"
import { Container } from "reactstrap"
import { useTranslation } from "react-i18next"
const { Text } = Typography

const EmbeddedBookingLayout = ({ children, setActiveTab, activeTab, onNext, type, mode, selectedPaymentProvider, isNextDisabled }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { uuid, id } = useParams()
  const loggedIn = localStorage.getItem("access_token")
  const selectedPaymentMethodId = useSelector(selectedPaymentMethodIdSelector)
  const location = useLocation()
  const isGuideProfileBooking = location.pathname.includes("guide-profile/experience_booking")
  const { isSportsman } = useTheme()

  return (
     <Container className="pt-xs">
      {children}
      <footer className={styles.footer}>
        {!mode && (
          <Flex gap={6} align="center">
            <Text>Powered By</Text>
            <Text secondary>{isSportsman ? t("select_adventure_mode.sportsman") : t("select_adventure_mode.sportswoman")}</Text>
          </Flex>
        )}
        {!type && (
          <Flex gap={8} className={styles.formButtons}>
            {activeTab === 1 && !isGuideProfileBooking && (
              <Button
                color="primary"
                variant="outlined"
                onClick={() => {
                  if (mode) {
                    navigate(routes?.tripPath({ id: id }))
                  } else {
                    navigate(routes?.embeddedExperienceDetail({ uuid: uuid, id: id }))
                  }
                }}
              >
                Back to Experience Detail
              </Button>
            )}
            {activeTab > 1 && (
              <Button
                color="primary"
                variant="outlined"
                onClick={() => {
                  setActiveTab(activeTab - 1)
                }}
              >
                Previous
              </Button>
            )}
            {/* Hide Submit Payment button on tab 3 when PayPal is selected */}
            {(activeTab !== 3 || selectedPaymentProvider !== "paypal") && (
              <Button
                type="primary"
                disabled={isNextDisabled || (mode && loggedIn && !selectedPaymentMethodId && activeTab === 3)}
                onClick={() => {
                  onNext()
                }}
              >
                {activeTab === 3 ? "Submit Payment" : "Next"}
              </Button>
            )}
          </Flex>
        )}
      </footer>
    </Container>
  )
}

export default EmbeddedBookingLayout

EmbeddedBookingLayout.propTypes = {
  children: PropTypes.node.isRequired,
  setActiveTab: PropTypes.func,
  activeTab: PropTypes.number,
  onNext: PropTypes.func,
  type: PropTypes.string,
  mode: PropTypes.string,
  selectedPaymentProvider: PropTypes.string,
  isNextDisabled: PropTypes.bool
}
